var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLevelArrow = function SvgLevelArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H4.24444C3.80885 17 3.59105 17 3.42467 16.9152C3.27833 16.8407 3.15934 16.7217 3.08477 16.5753C3 16.4089 3 16.1912 3 15.7556V3M17 6.11111L12.7733 10.3378C12.6193 10.4918 12.5423 10.5688 12.4535 10.5977C12.3754 10.623 12.2913 10.623 12.2132 10.5977C12.1244 10.5688 12.0474 10.4918 11.8934 10.3378L10.44 8.88442C10.286 8.73042 10.209 8.65341 10.1202 8.62456C10.0421 8.59918 9.95793 8.59918 9.87983 8.62456C9.79103 8.65341 9.71403 8.73042 9.56002 8.88442L6.11111 12.3333M17 6.11111H13.8889M17 6.11111V9.22222",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLevelArrow;